import { render, staticRenderFns } from "./RegistrationComponent.vue?vue&type=template&id=4912345f&scoped=true"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrationComponent.vue?vue&type=style&index=0&id=4912345f&prod&scoped=true&lang=css"
import style1 from "./RegistrationComponent.vue?vue&type=style&index=1&id=4912345f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912345f",
  null
  
)

export default component.exports